import "./src/styles/global.css";
import React from "react";
import { AuthProvider } from "./src/context/AuthContext";
import { NavigationProvider } from "./src/context/NavigationContext";
import { SidebarProvider } from "./src/context/SidebarContext";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return React.createElement(
    AuthProvider,
    null,
    React.createElement(
      NavigationProvider,
      null,
      React.createElement(SidebarProvider, null, element)
    )
  );
};
